module.exports = __webpack_public_path__ + "img/zhaopin.a9a47572.svg";